module.exports = __webpack_public_path__ + "img/Goin_3.a258edb5.jpg";